import { makeStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(4),
    minHeight: "100vh",
    backgroundColor: "#F6F8FA",
  },
  mainContent: {
    marginLeft: 180,
    // La marge de la sidebar s'ajoute à la largeur : avec width 100% la boîte
    // débordait de 180px et provoquait un scroll horizontal inutile.
    width: "calc(100% - 180px)",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      width: "100%",
      marginTop: 80,
    },
  },
  container: {
    maxWidth: 600,
    width: "100%",
    backgroundColor: "white",
    borderRadius: 16,
    padding: theme.spacing(4),
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: theme.spacing(4),
    color: "#2A3142",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  checkbox: {
    color: "#5E77FF",
    "&.Mui-checked": {
      color: "#5E77FF",
    },
  },
  checkboxLabel: {
    fontSize: 16,
    color: "#2A3142",
  },
  priceContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  priceLabel: {
    fontSize: 14,
    color: "#697386",
  },
  labelWithInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  sectionDivider: {
    borderColor: "#E0E0E0",
    marginTop: 0,
  },
  priceHelper: {
    fontSize: "0.75rem",
    color: "#697386",
  },
  blockingHint: {
    fontSize: "0.8rem",
    color: "#DC2626",
    fontWeight: 500,
  },
  priceInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      "& fieldset": {
        borderColor: "#E0E0E0",
      },
      "&:hover fieldset": {
        borderColor: "#5E77FF",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#5E77FF",
      },
    },
  },
  saveButton: {
    backgroundColor: "#5E77FF",
    color: "white",
    textTransform: "none",
    borderRadius: 8,
    padding: "12px 24px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#4A5FD1",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #5E77FF",
      outlineOffset: 2,
    },
  },
  "@media (max-width: 600px)": {
    root: {
      padding: theme.spacing(2),
    },
    container: {
      padding: theme.spacing(3),
    },
  },
  commissionsContainer: {
    marginTop: theme.spacing(0),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: "none",
    border: "1px solid #E0E0E0",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  commissionItem: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(0),
    padding: theme.spacing(1),
    backgroundColor: "#F6F8FA",
    borderRadius: 8,
    "&:last-child": {
      marginBottom: 0,
    },
  },
  commissionTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  commissionSubtitle: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
  },
  commissionInfo: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
  },
  commissionText: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  stripeLink: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    alignSelf: "flex-start",
    "&:hover, &:focus-visible": {
      textDecoration: "underline",
    },
  },
});

export default styles;
